var map = {
	"./cinema-11.png": 1381,
	"./cinema-12.png": 1382,
	"./cinema-13.png": 1383,
	"./cinema-14.png": 1384,
	"./cinema-15.png": 1385,
	"./cinema-16.png": 1386,
	"./cinema-17.png": 1387,
	"./cinema-18.png": 1388
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1380;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img ^\.\/cinema\-1.*\.png$
// module id = 1380
// module chunks = 4